(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ObjectTypesDeviceReleasesController', ObjectTypesDeviceReleasesController);

    ObjectTypesDeviceReleasesController.$inject = ['$scope', '$state', '$stateParams', 'TabDeviceReleases', 'TabObjectTypes', 'TabDevices','entity'];

    function ObjectTypesDeviceReleasesController($scope, $state, $stateParams, TabDeviceReleases, TabObjectTypes, TabDevices ,entity) {
        var vm = this;
        vm.tabObjectTypes = entity;
        vm.deviceReleasesForced = {};
        vm.tabDeviceReleases = [];
        vm.loadReleases = loadReleases;
        vm.clearDependency = clearDependency;

        vm.tabObjectTypes.$promise.then(function (data) {
            vm.tabDevices = data.devices;
            vm.loadReleases(vm.tabDevices);
            vm.tabObjectTypes.deviceReleases.forEach(function (release) {
                vm.deviceReleasesForced[release.deviceReleaseName] = release;
            });
            console.log(vm.deviceReleasesForced);
        });

        function loadReleases(tabDevice) {
            for (var i = 0; i < tabDevice.length; ++i) {
                vm.tabDeviceReleases.push(TabDeviceReleases.filterType({deviceId: tabDevice[i].id}));
            }

        }

        function clearDependency(release){
            delete vm.deviceReleasesForced[release];
        }

        var formatReleases = function () {
            vm.tabObjectTypes.deviceReleases = Object.keys(vm.deviceReleasesForced).map(function (value) {
                if (value)
                    return vm.deviceReleasesForced[value];
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabObjectTypesUpdate', result);
            vm.isSaving = false;
            $state.go('tab-object-types');
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            formatReleases();
            vm.isSaving = true;
            if (vm.tabObjectTypes.id !== null) {
                TabObjectTypes.update(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            } else {
                TabObjectTypes.save(vm.tabObjectTypes, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-object-types');
        };


    }

})();
